import { formatCode, formatSeconds } from './format';
import { errorText, useCreateLinkCode, useSecondsLeft } from './useAccountLink';

/** Telegram: выдать одноразовый код для ВКонтакте или Одноклассников. */
export function IssueCodePanel() {
  const createCode = useCreateLinkCode();
  const secondsLeft = useSecondsLeft(createCode.data?.deadline ?? null);
  const issued = createCode.data && secondsLeft > 0 ? createCode.data : null;

  return (
    <div className="flex flex-col gap-3 pt-4">
      {issued ? (
        <>
          <p className="text-sm text-text-2">
            Откройте Студию во ВКонтакте или Одноклассниках → Настройки → «Связанные площадки» и
            введите код:
          </p>
          <p className="text-4xl font-semibold tabular-nums tracking-widest text-text">
            {formatCode(issued.code)}
          </p>
          <p className="text-xs text-text-3">Код действует ещё {formatSeconds(secondsLeft)}.</p>
          <p className="text-sm text-text-2">
            Никому не сообщайте код — кто его введёт, получит доступ к вашему аккаунту.
          </p>
        </>
      ) : (
        <button
          type="button"
          onClick={() => createCode.mutate()}
          disabled={createCode.isPending}
          className="btn btn-primary self-start px-4 py-3 text-sm"
        >
          {createCode.isPending
            ? 'Получаем код…'
            : createCode.data
              ? 'Получить новый код'
              : 'Привязать ВКонтакте или Одноклассники'}
        </button>
      )}

      {createCode.isError && (
        <p role="alert" className="text-sm text-danger">
          {errorText(createCode.error)}
        </p>
      )}
    </div>
  );
}
